var _rect, _rect2, _rect3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationMenuInquiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3418,
    y: 8.45508,
    width: 2.93945,
    height: 5.09375,
    rx: 1.46973,
    stroke: "#555555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5137,
    y: 14.9199,
    width: 1.99805,
    height: 3.63753,
    rx: 0.999023,
    transform: "rotate(90 12.5137 14.9199)",
    stroke: "#555555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1484,
    y: 8.45508,
    width: 2.93945,
    height: 5.09375,
    rx: 1.46973,
    stroke: "#555555"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 15.9603H13.9336C14.49 15.9653 15.6029 15.5271 15.6029 13.7344",
    stroke: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3457 9.98047C4.34583 7.63742 4.92495 2.58203 10.7975 2.58203C12.8859 2.59077 17.0625 4.01441 17.0625 9.63908",
    stroke: "#555555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationMenuInquiry);
export default __webpack_public_path__ + "static/media/application-menu-inquiry.210f469d6909588b1b4cecabf88f0e3d.svg";
export { ForwardRef as ReactComponent };